"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.checkUpload = exports.sendUrlUpload = exports.sendFileUpload = void 0;
/**
 * Upload
 */
var send_upload_1 = require("./send-upload");
var localStorage_1 = require("../localStorage");
var helpers_1 = require("../helpers");
function sendFileUpload(file, progressCallback) {
    var data = new FormData();
    data.append('file', file);
    data.append('data', JSON.stringify({
        user_uuid: localStorage_1.getUserUUID(),
        user_flag: true,
        isUrl: false,
        service: 'device',
        mobile: helpers_1.checkMobile()
    }));
    return send_upload_1.sendUpload(data, progressCallback).then(function (response) {
        if (response.data.status !== 'error') {
            localStorage_1.refreshStorage(response.data);
        }
        return response.data;
    });
}
exports.sendFileUpload = sendFileUpload;
function sendUrlUpload(service, url, progressCallback, googleFileId, googleToken) {
    return __awaiter(this, void 0, void 0, function () {
        var gfile, data;
        return __generator(this, function (_a) {
            gfile = !!googleFileId && !!googleToken ? { file_id: googleFileId, g_token: googleToken } : {};
            data = new FormData();
            data.append('data', JSON.stringify(__assign(__assign({ user_uuid: localStorage_1.getUserUUID(), user_flag: true, isUrl: true, mobile: helpers_1.checkMobile(), url: url }, gfile), { service: service })));
            return [2 /*return*/, send_upload_1.sendUpload(data, progressCallback).then(function (response) {
                    if (response.data.status !== 'error') {
                        localStorage_1.refreshStorage(response.data);
                    }
                    return response.data;
                })];
        });
    });
}
exports.sendUrlUpload = sendUrlUpload;
function checkUpload(documentId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, send_upload_1.checkUploadRequest(documentId, localStorage_1.getUserUUID(), localStorage_1.getSessionUUID(documentId)).then(function (response) {
                    if (response.data.status !== 'error') {
                        localStorage_1.refreshStorage(response.data);
                    }
                    return response.data;
                })];
        });
    });
}
exports.checkUpload = checkUpload;
